import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';

function ApproveTimesheetModal({ id, nameEntered }) {
  const [name, setName] = useState('');

  return (
    <Modal
      id={id}
      icon="pe-7s-help1"
      iconGradient="bg-green-blue-top"
      title="Please enter your name"
      contentClass="modal-body-center-h"
      confirmText="Approve Timesheet"
      confirmButtonDisabled={!name.length}
      backdrop
      confirmHandler={() => nameEntered(name)}>
      <div className="row">
        <div className="col">
          <input
            type="text"
            className="form-control"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            />
        </div>
      </div>
    </Modal>
  );
}

ApproveTimesheetModal.propTypes = {
  id: PropTypes.any.isRequired,
  nameEntered: PropTypes.func,
};

export default memo(ApproveTimesheetModal);
